import { useEffect, useState } from "react";
import useAccount from "../authorization/useAccount";
import useFirestore from "../common/useFirestore";
import { useNavigate } from "react-router-dom";

function useCart(){
    const uid = sessionStorage.getItem("uid");
    const navigate = useNavigate();
    const {getCommonUser} = useAccount(uid);
    const {readFirestore, readFirestoreOneDoc, addFirestore} = useFirestore();
    const [cartItemList, setCartItemList] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedItemList, setSelectedItemList] = useState([]);
    const [selectedTotalAmount, setSelectedTotalAmount] = useState(0);
    const [modal, setModal] = useState({
        title:"",
        content:"",
        onConfirmClickHandler:() => {}
    });
    useEffect(() => {
       getCart();
    }, [])

    const getCart = async() => {
        const cart_list = await getCartList();
        if(!cart_list.length){
            setModal({
                title:"ERROR",
                content:"장바구니에 항목이 없습니다",
                onConfirmClickHandler:() => navigate(-1, {replace:true})
            })
            setIsOpenModal(true);
        }
        const item_list = await getCartItemList(cart_list);
        setCartItemList(item_list);
        return item_list;
    }

    const getCartList = async() => {
        const user = await getCommonUser();
        if(!user){
            setModal({
                title:"ERROR",
                content:"사용자를 찾을 수 없습니다\n다시 로그인 해주세요",
                onConfirmClickHandler:() => navigate("/login")
            })
            setIsOpenModal(true);
            return ;
        }
        const cart_list = await readFirestore(`Cart/${user.id}/Item`).then(res => {
            const list = [];
            if(!res.empty){
                const doc_list = res.docs;
                for(const doc of doc_list){
                    list.push({id:doc.id, ...doc.data()})
                }
            }
            return list;
        })

        return cart_list;
    }

    const getCartItemList = async(cart_list) => {
        const item_list = [];
        for(const cart of cart_list){
            const item = await readFirestoreOneDoc(`Product`, cart.id).then(res => {
                if(res.exists()){
                    return res.data();
                }
                return null;
            })
            if(!item){
                continue;
            }
            item_list.push({
                id:cart.id,
                thumbnail_img:item.thumbnail_img,
                title:item.title,
                class:item.class_list.filter(_class => _class.id === cart.class)[0],
                option_list:item.option_list.filter(option => cart.option_list.includes(option.id)),
            })
        }
        return item_list;
    }

    const onCartItemClickHandler = (item, itemAmount) => {
        if(selectedItemList.includes(item)){
            setSelectedItemList(prev => prev.filter(selected => selected.id !== item.id));
            setSelectedTotalAmount(prev => prev - itemAmount)
        }else{
            setSelectedItemList(prev => [...prev, item]);
            setSelectedTotalAmount(prev => prev + itemAmount)
        }
    }

    const createOrder = async(user, data) => {
        const order_id = await addFirestore(`Pay/${user.id}/Order`, data).then(res => {
            if(res){
                return res;
            }
            return null;
        })
        return order_id;
    }

    const onPayClickHandler = async() => {
        const user = await getCommonUser();
        if(!user){
            setModal({
                title:"ERROR",
                content:"사용자를 찾을 수 없습니다\n다시 로그인 해주세요",
                onConfirmClickHandler:() => navigate("/login")
            })
            setIsOpenModal(true);
            return ;
        }
        const cart_list = await getCart();
        const selected_list = cart_list.filter(item => selectedItemList.includes(item.id));
        const data = {
            item:selected_list,
            total_amount:selectedTotalAmount,
            state:"REGISTERED"
        }
        const order_id = await createOrder(user, data);
        if(order_id){
            navigate(`/pay/${order_id}`);
        }else{
            setModal({
                title:"ERROR",
                content:"주문을 생성할 수 없습니다\n재시도 해주세요",
                onConfirmClickHandler:() => setIsOpenModal(false)
            })
            setIsOpenModal(true);
            return ;
        }
    }

    

    return {cartItemList, isOpenModal, modal, selectedItemList, onCartItemClickHandler, selectedTotalAmount, onPayClickHandler}
}


export default useCart;